import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#4efdec',
        secondary: '#4efdec',
        accent: '#8c9eff',
        
      },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 680,
      md: 920,
      lg: 1280,
    },

  },
});
